import { apiFetch } from "./client.ts";

export type TechnicianStatus = "available" | "busy" | "off_duty" | "on_break";

export interface Technician {
  id: string;
  account_id: string;
  user_id: string;
  skills: string[] | null;
  certifications: string[] | null;
  home_base_address: string | null;
  home_base_lat: string | null;
  home_base_lng: string | null;
  commission_pct: string;
  avatar_url: string | null;
  timezone: string;
  status: TechnicianStatus;
  created_at: string;
  updated_at: string;
  user_full_name?: string | null;
  user_email?: string | null;
}

export interface TechnicianList {
  items: Technician[];
  total: number;
}

export async function listTechnicians(params: { status?: TechnicianStatus } = {}): Promise<TechnicianList> {
  const usp = new URLSearchParams();
  if (params.status) usp.set("status", params.status);
  return apiFetch<TechnicianList>(`/technicians?${usp}`);
}

export async function createTechnician(payload: {
  user_id: string;
  skills?: string[];
  certifications?: string[];
  home_base_address?: string;
  commission_pct?: number;
  avatar_url?: string;
  timezone?: string;
}): Promise<Technician> {
  return apiFetch<Technician>("/technicians", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export async function updateTechnician(id: string, patch: Partial<Technician>): Promise<Technician> {
  return apiFetch<Technician>(`/technicians/${id}`, {
    method: "PATCH",
    body: JSON.stringify(patch),
  });
}

export async function deleteTechnician(id: string): Promise<void> {
  await apiFetch<void>(`/technicians/${id}`, { method: "DELETE" });
}
